import { render, staticRenderFns } from "./bookingBox.vue?vue&type=template&id=363f5eb4&scoped=true&"
import script from "./bookingBox.vue?vue&type=script&lang=js&"
export * from "./bookingBox.vue?vue&type=script&lang=js&"
import style0 from "./bookingBox.vue?vue&type=style&index=0&id=363f5eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f5eb4",
  null
  
)

export default component.exports